import React                 from 'react';
import { Observe }                from 'rewire-core';
import Button                     from '@material-ui/core/Button';
import AddIcon                    from '@material-ui/icons/AddCircleOutline';
import timeOffBalancesDialogModel from '../schedule/TimeOffBalancesDialogModel';
import MessagesView               from '../timecard/MessagesView';
import RowSelectionGrid           from '../ui/RowSelectionGrid';
import { Theme, makeStyles }      from '../utility/styles';

const styles = (theme: Theme) => ({
  button: {
    minWidth: '100px',
    minHeight: '0px',
    padding: '5px',
  },
  header: {
    display: 'flex',
    flex: '1 0 auto',
    alignItems: 'center',
  },
  icon: {
    marginRight: '6px',
    color: theme.palette.success.main,
  },
  divider: {
    marginTop: '12px',
  },
  grid: {
    marginTop: '6px',
    maxHeight: '345px',
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
  },
});

const useStyles = makeStyles(styles);

export default (_props: unknown): JSX.Element | null => {
  const classes       = useStyles();
  const gridFontSizes = {
    header:     '0.75em',
    body:       '0.75em',
    groupRow:   '1em',
    toggleMenu: '0.8em',
  };

  return <Observe render={() => {
    return (
      <div>
        <span className={classes.header}>
          <Observe render={() => (
            <Button variant='contained' className={classes.button} disabled={!timeOffBalancesDialogModel.canAddAccrual} onClick={timeOffBalancesDialogModel.handleAddAccrual} ><AddIcon className={classes.icon} />Add Accrual...</Button>
          )} />
        </span>

        <RowSelectionGrid grid={timeOffBalancesDialogModel.transactionsGrid} className={classes.grid} gridFontSizes={gridFontSizes}/>
        <MessagesView className={classes.divider} title='Messages' messages={timeOffBalancesDialogModel.messages} />
      </div>
    );
   }} />;
};
